export function generateTextAreaConfig(toolbarId?: string) {
    const config = {
        modules: {
            toolbar: false,
        },
        formats: ['bold', 'italic', 'list', 'link'],
        images: false,
        formatLinks: false,
        useDivs: true,
        placeholders: false,
    } as const;

    if (toolbarId) {
        // @ts-expect-error
        config.toolbarId = toolbarId;
    }

    return config;
}

export function handleFileUpload(setLogo: (arg1: string) => void) {
    const filepickerClient = Nut.modules.Global.init.configureFilePicker();

    const filestackOptions = {
        maxSize: 52428800,
        uploadInBackground: false,
        fromSources: [
            'local_file_system',
            // TODO: Re-enable cloud sources once Filestack integration issues are resolved
            // 'googledrive',
            // 'dropbox',
            // 'box',
        ],
        // @ts-expect-error
        onUploadDone(newFiles) {
            setLogo(newFiles.filesUploaded[0].url);
        },
        // @ts-expect-error
        onFileUploadFailed(file, error) {
            // eslint-disable-next-line no-console
            console.error('FilePicker error', error, 'for file', file);
            // @ts-expect-error
            if (typeof window.trackJs !== 'undefined') {
                // @ts-expect-error
                window.trackJs.track(
                    `FilePicker error: ${error.message} -- ${error.details} -- ${error.stack}`
                );
            }
        },
    } as const;

    try {
        filepickerClient.picker(filestackOptions).open();
    } catch (error: any) {
        // eslint-disable-next-line no-console
        console.error(error.message, error.details);
        // @ts-expect-error
        if (typeof window.trackJs !== 'undefined') {
            // @ts-expect-error
            window.trackJs.track(`${error.message}: ${JSON.stringify(error.details)}`);
        }
    }
}
